import React from 'react';
import validator from 'validator';
import { Formik, Form, Field } from 'formik';
import AutocompleteLocalidad from '../Commons/AutocompleteLocalidad.jsx';
import map from 'lodash/map';
import { stringify } from 'rebem-classname';

export default function RenderFormCliente(props){
	const block = "RenderFormPublicar";
	
	const area = props.to ? map(props.to, t => ({...t})) : [];
	
	let mensajePredefinido = '';
	if (props.accion == 'pagar-ahora') {
		mensajePredefinido = 'Hola, soy el dueño del anuncio '+props.referencia+' me comunico para realizar el pago correspondiente';
	}
	
	const options = map(area, pro => <option key={pro.value} value={pro.value}>{pro.label}</option>);
	let formContactarOMensaje = <Formik
		initialValues={{
			nombreApellido:'',
			telefono:'',
			email:'',
			referencia:'',
			localidad:null,
			area: props.hacia || 0,
			referencia: props.referencia || '',
			mensaje: mensajePredefinido,
		}}
		onSubmit={props.onSubmit}
		validate={({nombreApellido, telefono, email, area, mensaje}) => {
			let errores = {};
			if(!email){
				errores.email = 'El email es requerido';
			} else if(!validator.isEmail(email)){
				errores.email = 'El email ingresado no es valido';
			}
			if(!mensaje){
				errores.mensaje = 'El Comentario es requerido';
			} else if(mensaje.length>350) {
				errores.mensaje = 'El Comentario debe tener como maximo 350 caracteres';
			}
			if (!area) {
				errores.area = 'Seleccione un área';
			}
			if (!nombreApellido) {
				errores.nombreApellido = 'Nombre es requerido';
			}
			if (!telefono) {
				telefono = 'Telefono es requerido';
			}
			return errores;
		}}
	>
		{({errors, touched}) => (<Form>
			<Field name="area" as="select">
				<option value={0} disabled hidden>Seleccione...</option>
				{options}
			</Field>
			{touched.area && errors.area && <div>{errors.area}</div>}
			<Field name="nombreApellido" placeholder="Nombre y Apellido * " className="" />
			{touched.nombreApellido && errors.nombreApellido && <div>{errors.nombreApellido}</div>}
			<Field name="telefono" type="tel" placeholder="Teléfono / Celular * " className=""/>
			{touched.telefono && errors.telefono && <div>{errors.telefono}</div>}
			<Field name="email" placeholder="Email " className=""/>
			{touched.email && errors.email && <div>{errors.email}</div>}
			<Field name="referencia" placeholder="Referencia " className=""/>
			{touched.referencia && errors.referencia && <div>{errors.referencia}</div>}
			<Field name="localidad">
				{({
					field: { value, onChange },
					form: { touched, errors, setFieldValue, values }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
					meta,
				}) => { 
					const onLugarClear = () => setFieldValue('localidad',null);
					const onLugarSelected = lugar => setFieldValue('localidad',lugar);
					const localidadConsultada = value;
					return <AutocompleteLocalidad
						onLugarClear={onLugarClear} 
						onLugarSelected={onLugarSelected}
						idProvincia={values && values.provincia ? values.provincia : null}
					/>
				}}
			</Field>
			{touched.localidad && errors.localidad && <div>{errors.localidad}</div>}
			<Field as="textarea" maxLength="350" name="mensaje" placeholder="Mensaje (*)" className=""/>
			{touched.mensaje && errors.mensaje && <div>{errors.mensaje}</div>}
			<button type="submit" className="btn btn-naranja">Enviar</button>
		</Form>)}
	</Formik>;

	if (props.mostrarMensajeDeEnvio) {
		formContactarOMensaje = <div className={stringify({block, elem:"mensaje_ok"})}>
			<span>Muchas Gracias por su contacto. Nos comunicaremos a la brevedad</span>
			<span className={stringify({block, elem:"ok glyphicon glyphicon-ok"})}></span>
		</div>;
	}

	return <div className={stringify({block, className:"container-fluid"})}>
		<div className={stringify({block, elem:"formularios"})}>
			{formContactarOMensaje}
		</div>
	</div>;
}
